import { IEditTierDTO, IReferenceDTO  } from "../../../services/alarm-scheme-data-service/Models";
import { IReferenceNotificationListDTO as SetpointReferenceNotificationListDTO } from "../../../services/setpoint-administration-service/Models"
import { AlarmNotificationTypeEnum } from "../../../common/enums/AlarmNotificationTypeEnum";
import { AlarmSchemeTierType } from "../../alarm-scheme-tier-card/AlarmSchemeTierUtils";
import Enumerable from "linq";
import { NotificationListsFormType } from "../../form-notification-lists/FormNotificationListsUtils";
import { ActionMenuItem, BaseActions } from "../../action-menu/ActionMenuItem";
import i18n from "../../../services/localization-service/i18n";
import { AddIcon } from "../../action-menu/ActionMenuIcons";


export enum TierAdminMode {
    Add = 0,
    Edit = 1
}

export enum StepEnum {
    Settings = 1,
    Notifications = 2,
}


export enum TierNotificationActions  {
    Add = 'add',
    AddScheduledNotification = 'addschedulednotification'
}

export type TierNotificationActionItem = {
    action: TierNotificationActions | BaseActions | string
} & ActionMenuItem;


export const tierNotificationActionItems: TierNotificationActionItem[] = [{
    label: i18n.t("buttons.newNotificationList"),
    icon: AddIcon,
    action: TierNotificationActions.Add,
    order: 0
},{
    label: i18n.t("alarmSchemeAdmin.tiers.buttons.addScheduledNotification"),
    icon: AddIcon,
    action: TierNotificationActions.AddScheduledNotification,
    order: 0
}];


export type TierFormNotificationListType = {

    id: number;
    name: string;

    organizationID: number;
    organizationName: string;

    selected?: boolean;
}


export type NotificationListFormType = {
    id: number,
    name: string,
    organizationID: number,
    organizationName: string,
    selected: boolean
}
export type ScheduleFormType = {
    id: number,
    name: string,
    selected: boolean,
} & NotificationListsFormType

export type TierFormType = {
    description: string;
    maxRepeats: number;
    schedules: ScheduleFormType[];
    useScheduledNotifications: boolean;

    tiers: IEditTierDTO [];

} & Omit<IEditTierDTO, 'schedules'> & NotificationListsFormType;

export const defaultEditTier: TierFormType = {
    id: 0,
    name: '',
    type: AlarmNotificationTypeEnum.Once,
    delayMinutes: 0,
    description: '',
    schedules: [],
    notificationLists: [],
    maxRepeats: 0,
    useScheduledNotifications: false,
    tiers: []
}


const TierEditorUtils = {

    mapToForm: (model: AlarmSchemeTierType, 
        referenceData: IReferenceDTO,
        tiers: IEditTierDTO[]
        ): TierFormType  => {


            const formValue: TierFormType = {

                id: model.id,
                name: model.name,
                type: model.type,
                delayMinutes: model.delayMinutes,
                repeatCount: model.type !== AlarmNotificationTypeEnum.Once ? model.repeatCount : undefined,
                repeatMinutes: model.type === AlarmNotificationTypeEnum.EveryXMinutes ? 
                                model.repeatMinutes :
                                undefined,
                repeatZCount: model.type === AlarmNotificationTypeEnum.ZTimesYMinutesApart ? 
                                model.repeatCount ?? model.repeatZCount :
                                undefined,
                repeatCountMinutes: model.type === AlarmNotificationTypeEnum.ZTimesYMinutesApart ? 
                                    model.repeatMinutes :
                                    undefined,
                description: model.description ?? '',
                schedules: [],
                notificationLists: [],
                //notifications: [],
                maxRepeats: referenceData.maxAlarmRepeatLimit,
                useScheduledNotifications: model.useScheduledNotifications,
                tiers: tiers
                
            };

            referenceData.organizations.forEach(o => {
                o.notificationLists.forEach(v => {

                    formValue.notificationLists.push({
                        id: v.id,
                        name: v.name,
                        organizationID: o.id,
                        selected: model.schedules.find(z => z.notificationListID === v.id) ? true : false
                    } as SetpointReferenceNotificationListDTO );
                })
            });

            formValue.schedules = Enumerable.from(model.schedules)
                .groupBy(o => o.scheduleID)
                .select(o => {

                    const scheduleID = o.key();

                    const schedule: ScheduleFormType = {
                        id: scheduleID,
                        name: referenceData.schedules.find(v => v.id === scheduleID)?.name ?? '',
                        notificationLists: [],
                        selected: true
                    };

                    o.toArray().forEach(v => {

                        const organization = referenceData.organizations
                                                .find(a => a.notificationLists
                                                    .find(x => x.id ===  v.notificationListID));

                        const notificationList: NotificationListFormType = {
                            id: v.notificationListID,
                            organizationID: organization?.id ?? 0,
                            organizationName: organization?.name ?? '',
                            name: organization?.notificationLists.find(x => x.id === v.notificationListID)?.name ?? '',
                            selected: true
                        };
    
                        schedule.notificationLists.push(notificationList);
                    });

   
    
                    return schedule;
                }).toArray();
    

            // referenceData.organizations.forEach(o => {


                



            //     formValue.notifications = formValue.notifications.concat(o.notificationLists.map(v => {
            //         const notification: TierFormNotificationListType = {
            //             organizationID: o.id,
            //             organizationName: o.name,
            //             id: v.id,
            //             name: v.name,
            //             selected: model.notifications.find(x => x.notificationListID === v.id) !== undefined ? true : false
            //         };

            //         return notification;
            //     }));

            // })



            return formValue;

    },
}


export default TierEditorUtils;






